import { call, take, put, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from '../config/firebase'

import RolePermissionActions from '../reducers/rolePermissionReducer'
import AuthActions from '../reducers/authReducer'

const observerRoles = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        emit(data.val())
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  })

  return listener
}

const observerModules = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        const newObj = {}

        data.forEach(obj => {
          newObj[obj.key] = obj.val()
        })

        emit(newObj)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  })

  return listener
}

const userRoleObserver = ref => {
  const listener = eventChannel(emit => {
    const unsub = ref.onSnapshot(snapshot => {
      if (snapshot.exists) {
        const user = snapshot.data()
        emit(user.role)
      } else {
        emit({})
      }
    }, () => emit({}))

    return unsub
  })

  return listener
}

export function* trackCurrentUserRole({ uid }) {
  const userDoc = firebase.firestore().collection('dashboard_users').doc(uid)

  const listener = yield call(userRoleObserver, userDoc)

  try {
    while (true) {
      const role = yield take(listener)

      yield put(AuthActions.setAuthField('role', role ))
    }
  } finally {
    listener.close()
  }
}

export function* getAllRolesPermissions() {
  const database = firebase.database()
  const rolePermissionRef = database.ref('roles').orderByChild('name')

  const databaseEventChannel = yield call(observerRoles, rolePermissionRef) // listening databaseEvent
  try {
    while (true) {
      const roles = yield take(databaseEventChannel) // take event data
      const auth = yield select(state => state.auth.data)

      const isOperatorAdmin = auth.role !== 'operator@role' && roles[auth.role].access.includes('orders')
      yield put(AuthActions.setAuthField('isOperatorAdmin', isOperatorAdmin))
      yield put(RolePermissionActions.getAllRolesSuccess(roles))
    }
  } catch (error) {
    yield put(RolePermissionActions.getAllRolesFailure(error))
  } finally {
    databaseEventChannel.close()
  }
}

export function* getAllModules() {
  const database = firebase.database()
  const moduleRef = database.ref('modules')

  const databaseEventChannel = yield call(observerModules, moduleRef) // listening databaseEvent
  try {
    while (true) {
      const modules = yield take(databaseEventChannel) // take event data

      yield put(RolePermissionActions.getAllModulesSuccess(modules))
    }
  } catch (error) {
    yield put(RolePermissionActions.getAllModulesFailure(error))
  } finally {
    databaseEventChannel.close()
  }
}



// WEBPACK FOOTER //
// ./src/sagas/rolePermissionSaga.js